module.exports = __webpack_public_path__ + "media/images/shift_double_sp-426464aae879f52deeb63a815e6e5e6e.png";